export default __webpack_public_path__ + "static/media/manana-off.c9a9b15e.svg";